<template>
  <div class="about">
    <!-- App Title  -->
    <AppTitle></AppTitle>

    <!-- ContentTitle -->
    <div class="content-title">
      <h2>ABOUT ME</h2>
      <img src="../assets/images/logotitle (2).png" alt="타이틀이미지">
    </div>

    <div class="content">
      <!-- top-content -->
      <div class="top-content">
        <div class="s-content">
          <div class="photo"></div>
          <h2>Son Ah Young</h2>
          <p>Web Publisher</p>
        </div>
      </div>
      <!-- bottom-content -->
      <div class="bottom-content">

        <div class="top-text">
          <p><i class='fa fa-quote-right rotate' aria-hidden='true'></i> 항상 새로운 것을 받아들이고</p>
          <p style="text-indent:40px;">보고느끼고 공부하는 퍼블리셔 <i class='fa  fa-quote-right rotate1' aria-hidden='true'></i></p>
        </div>

        <div class="bottom-text">
          <p>항상 배움을 멈추지않고 빠르게 달라지는 트랜드에 발을 맞출 수 있는 퍼블리셔가 되고 싶습니다.<br> 현실에 안주하지 않고 항상 새로운 것을 배우고<br> 익히며늘 발전하고 노력해서 어디서든
            필요로 하는 웹퍼블리셔로 성장 할 것입니다.</p>
        </div>
      </div>
    </div>

    <!-- ContentTitle -->
    <div class="content-title">
      <h2>ADVANTAGES</h2>
      <img src="../assets/images/logotitle (1).png" alt="타이틀이미지">
    </div>
    <!-- Advantages Area Start -->
    <div class="footer">
      <div class="box">
        <img src="../assets/images/꼼꼼함.png" alt="photos1">
        <div class="text_box">
          <h4>꼼꼼함</h4>
          <p>
            디자인 요소의 사이즈와 컬러 간격의
            차이가 결과물의 완성도를 좌우한다고
            생각합니다 꼼꼼함과 세심함으로 <br>
            결과물을 작업합니다.
          </p>
        </div>
      </div>
      <div class="box">
        <img src="../assets/images/책임감.png" alt="photos2">
        <div class="text_box">
          <h4>책임감</h4>
          <p>
            여러개의 작업물이라도 <br>
            책임감을가지고 끝까지 시간에 맟추어
            작업물을 완성합니다
          </p>
        </div>
      </div>
      <div class="box">
        <img src="../assets/images/커뮤니케이션.png" alt="photos3">
        <div class="text_box">
          <h4>커뮤니케이션</h4>
          <p>
            개발. 디자인 등 타직군과의 소통 을 <br>
            원할하게 진행하며 능동적인 <br>
            업무를 할수 있습니다.
          </p>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
import AppTitle from './component/Header.vue';
export default {
  name: "About",
  components: {
    AppTitle
  },
  mounted() {
    this.menuAct3();
  },
  methods: {
    menuAct3() {
      $('.About').removeClass('menu-act');
      $('.About').addClass('menu-act');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../sass/partials/_mixin.scss", "../sass/partials/variable.scss";

.about {
  background-color: $bg-color1;
  text-align: center;

  .content {
    margin: 0 auto 80px auto;
    width: 344px;
    height: 576px;
    border: 1px solid $m-bg1;
    -webkit-transition: all ease (0.8s);
    -moz-transition: all ease (0.8s);
    -o-transition: all ease (0.8s);
    transition: all ease (0.8s);

    &:hover{
        -webkit-transform: scale(1.05);
        -moz-transform: scale(1.05);
        -o-transform: scale(1.05);
        transform: scale(1.05);
      }

    .top-content {
      height: 363px;
      background-color: $m-bg1;
      @include flex(true, 'center', 'center', 0);
      flex-wrap: wrap;
      margin-bottom: 5px;

      .photo {
        width: 210px;
        height: 210px;
        background: url(../assets/images/home1.jpg)no-repeat 0 -20px / cover;
      }

      h2 {
        width: 100%;
        margin: 15px 0 5px 0;
        font: 800 30px "Lato", sans-serif;
      }

      p {
        font: 500 15px "Ubuntu", sans-serif;
        color: $color1;
      }
    }

    // bottom-content Area start
    .bottom-content {
      position: relative;
      padding: 20px;

      

      // top-text
      .top-text {
        p {
          width: 100%;
          font: bold 16px "나눔고딕", sans-serif;

          i {
            color: $m-bg1;
          }

          .rotate {
            display: inline-block;
            position: absolute;
            top: 10px;
            left: 45px;

            -webkit-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            transform: rotate(180deg);
          }

          .rotate1 {
            position: absolute;
            right: 20px;
          }
        }
      }

      // bottom-text
      .bottom-text {
        margin-top: 25px;

        p {
          font: 400 13px "맑은 고딕", sans-serif;
          // text-align:start;
        }
      }
    }
  }

  .footer {
    margin: 40px 0;
    padding-bottom: 88px;

    .box {
      width: 344px;
      height: 133px;
      border: 1px solid $bd;
      border-radius: 21px;
      margin: 17px auto;
      padding: 15px;
      @include flex(true, 'center', 'center', 0);
      -webkit-transition: all ease (0.8s);
      -moz-transition: all ease (0.8s);
      -o-transition: all ease (0.8s);
      transition: all ease (0.8s);

      
      &:hover{
        -webkit-transform: scale(1.1);
        -moz-transform: scale(1.1);
        -o-transform: scale(1.1);
        transform: scale(1.1);
      }

      img {
        height: 56px;
        float: left;
      }

      .text_box {
        width: 226px;
        text-align: start;
        float: right;
        margin-left: 20px;
        font: bold 15px "맑은 고딕", sans-serif;

        p {
          @include font-set(400, 13px, 17px, $ff3);
          padding-top: 6px;
        }
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/about.vue